'use client'

import { useEffect, useRef } from 'react'
import * as VKID from '@vkid/sdk'
import { useSignInTgMutation } from '@/shared/api-rtk'
import { API_URL } from '@/shared/constants/linksApi'
import { TG_BOT_NAME, VK_APP_KEY } from '@/shared/constants/social'

export const SocialAuth = () => {
    const vkAuth = () => {
        VKID.Auth.login()
    }

    const telegramWrapperRef = useRef(null)

    useEffect(() => {
        VKID.Config.set({
            app: VK_APP_KEY, // Идентификатор приложения.
            redirectUrl: API_URL + '/vkauth', // Адрес для перехода после авторизации.
        })
    }, [])

    useEffect(() => {
        const scriptElement = document.createElement('script')
        scriptElement.src = 'https://telegram.org/js/telegram-widget.js?22'
        scriptElement.setAttribute('data-telegram-login', TG_BOT_NAME)
        scriptElement.setAttribute('data-size', 'large')
        scriptElement.setAttribute('data-request-access', 'write')
        scriptElement.setAttribute('data-userpic', 'false')
        scriptElement.setAttribute('data-radius', '10')
        scriptElement.setAttribute('data-auth-url', API_URL + '/telegramauth')
        scriptElement.async = true
        telegramWrapperRef.current.appendChild(scriptElement)
    }, [])

    return (
        <div className={'SocialAuth'}>
            <div className={'title'}>
                <div className={'title-rect'}></div>
                <span>или войдите через мессенджеры</span>
                <div className={'title-rect'}></div>
            </div>
            <div className={'social-btn'}>
                <button onClick={vkAuth}>
                    <img src="/icons/socials-vk.svg" alt="" />
                    Вконтакте
                </button>
                <div ref={telegramWrapperRef}></div>
            </div>
        </div>
    )
}
